let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Sqz1")).then(() => parcelRequire('8sEmV'));